import GameObject from '../../../GameObject/GameObject';
import Game from '../../../Game';
import BasePopupHandler from './BasePopupHandler';
import Point from '../../../Utility/Point';
import BaseUISystem from '../BaseUISystem';
import Renderable from '../../../Component/Renderable';
import Text from '../../../Prototype/Text';
import Sprite from '../../../Prototype/Sprite';
import FriendHubScroll from '../../../Prototype/UI/Popup/FriendHub/FriendHubScroll';
import FriendItem from '../../../Prototype/UI/Popup/FriendHub/FriendItem';
import LeaderboardHelper from '../LeaderboardHelper';
import { GameActions } from '../../../State/Game/GameActions';
import TextComponent from '../../../Component/Render/Text';
import { FRIEND_SHARE_MAX_COUNT } from '../../../Constants/Player';
import SpriteComponent from '../../../Component/Render/Sprite';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { currencyShareReward } from '../../../Constants/Economy';
import { StartAnimation } from '../../Animation/AnimationHelper';
import WorldSystem from '../../World/WorldSystem';
import Element from '../../../Prototype/UI/Element';
import { track } from '../../../Utility/Tracking/Track';
import { TActionType, TransactionType, TSocialActionType } from '../../../Utility/Tracking/DataSet/Transaction';
import { trackResourceEvent } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { ContextType } from '../../../State/Game/ContextType';
import { IGameState } from '../../../State/Game/IGameState';
import { IScoreEntry } from '../../../Utility/SDK/Drivers/IScoreEntry';
import { report } from '../../../report';
import Timer from '../../Timer/Timers/Timer';
import { PopupID } from '../../../State/UI/PopupID';
import { Logger, LogOrigin } from '../../../Utility/Logger/LoggerSuite';

const PROGRESS_BAR_MAX_WIDTH: number = 500;
const FRIEND_ITEM_OFFSET: Point = new Point(-15, -85);
const SCROLL_AREA: string = 'friend_scroll_area';

export default class FriendsHubHandler extends BasePopupHandler {
    private timer: Timer;
    public static PROGRESS_BAR_NAME: string = 'friend_bar_progress';
    public static PROGRESS_TEXT_NAME: string = 'friend_bar_friend_count';

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.FRIENDS_HUB, uiSystem);
    }

    protected createPopup(params?: any): void {
        try {
            this.underlayParams.layout.anchors = [0.67, 0.5, 0.67, 0.5];
            this.underlayParams.layout.offsets = [-3, -10, -3, -10];
            this.underlayParams.cacheKey = 'blank';
            this.submitBtnParams = {
                ...this.submitBtnParams,
                text: {
                    ...this.submitBtnParams.text,
                    textLocalizationKey: 'Invite',
                    // layout: {
                    //     offsets: [0,40,0,40]
                    // },
                    style: {
                        ...Game.style.getStyle('popup.dark_blue_btn'),
                        fontSize: 55,
                    },
                },
                button: {
                    ...this.submitBtnParams.button,
                    cacheKey: 'button_medium_blue',
                },
                background: {
                    ...this.submitBtnParams.background,
                    layout: {
                        ...this.submitBtnParams.background.layout,
                        anchors: [0.24, 1, 0.24, 1],
                    },
                },
            };
            this.titleBgParams.layout.anchors = [0.5, 0, 0.5, 0];
            this.titleBgParams.layout.offsets = [0, 10, 0, 10];
            this.backgroundParams = {
                ...this.backgroundParams,
                layout: {
                    ...this.backgroundParams.layout,
                    constrains: {
                        heightMax: 722,
                        heightMin: 722,
                        widthMax: 1226,
                        widthMin: 1226,
                    },
                },
                cacheKey: 'base',
            };

            this.closeBtnParams.button.layout.anchors = [
                0.938,
                0.135,
                0.938,
                0.135,
            ];

            super.createPopup({
                buttons: [this.submitBtnParams, this.closeBtnParams],
                underlay: this.underlayParams,
            });

            this.title = Game.locale.getText('Friends');

            const base: GameObject = this.element.find('baseLayer');
            base.getComponent<Renderable>(Renderable).container.alpha = 0;

            this.createInviteSection();
            this.createScrollArea();
            this.createFriendsBar();
        } catch (error) {
            report('Failed to create FriendsHub', {
                error,
                once: true,
                sampleRate: 0.1,
            });
        }
    }
    public onShow(params: {}) {
        try {
            super.onShow(params);
            this.initTimer();

            LeaderboardHelper.loadTotalStarLeaderboard()
                .then(
                    this.fillFriendItems
                )
                .catch((err: Error) => {
                    Logger.log(err, LogOrigin.FRIENDS_HUB_HANDLER);
                });
        } catch (error) {
            console.log(error);
        }
    }
    public onShown(params?: any) {
        super.onShown(params);
        this.updateProgressBar();
    }

    protected onSubmit(): void {
        track('socialActionType', TSocialActionType.INVITE);
        GameActions.setContext(ContextType.INVITE_FRIEND, 'SocialHub');
    }
    protected createFriendsBar(): void {
        try {
            const background: GameObject = GameObject.Instantiate(Sprite, {
                name: 'friend_bar_bg',
                texture: 'bar_back',
                x: -320, // 303
                y: -157,
                anchor: new Point(0, 0.5),
            });
            this.background.find(this.underlayParams.name).addChild(background);
            const bar: GameObject = GameObject.Instantiate(Sprite, {
                name: FriendsHubHandler.PROGRESS_BAR_NAME,
                texture: 'gradient',
                x: 95,
                y: -2,
                width: 0,
                height: 42,
                anchor: new Point(0, 0.5),
            });
            const foreground: GameObject = GameObject.Instantiate(Sprite, {
                name: 'friend_bar_progress',
                texture: 'bar_front',
                x: 0,
                y: 0,
                anchor: new Point(0, 0.5),
            });
            background.addChild(bar);
            background.addChild(foreground);
            const friendBarCoin: GameObject = GameObject.Instantiate(Sprite, {
                name: 'friend_bar_Coin',
                texture: 'coin_glow',
                x: 10,
                y: -3, //17
                anchor: new Point(0, 0.5),
                scale: new Point(0.65, 0.65),
            });
            foreground.addChild(friendBarCoin);
            const basket: GameObject = GameObject.Instantiate(Sprite, {
                name: 'friend_bar_basket',
                texture: 'treasure_price',
                x: 580,
                y: -10,
                anchor: new Point(0.5, 0.6),
                scale: new Point(0.9, 0.9),
            });
            foreground.addChild(basket);
            const friendCount: GameObject = GameObject.Instantiate(Text, {
                name: FriendsHubHandler.PROGRESS_TEXT_NAME,
                text: '0 / 10',
                style: Game.style.getStyle('popup.friends_hub.friend_count'),
                x: 280,
                y: -3,
                anchor: new Point(0, 0.5),
            });
            foreground.addChild(friendCount);
        } catch (error) {
            console.log(error, 'createFriendsBar');
        }
    }
    protected createInviteSection(): void {
        const inviteSplash: GameObject = GameObject.Instantiate(Sprite, {
            name: 'invite_splash',
            texture: 'UI_friends_banner',
            x: 80,
            y: 165,
        });
        this.background.addChild(inviteSplash);
        // this.submitBtn.getComponent(UITextComponent).bounds = new Point(
        //     220,
        //     110
        // );
        this.background.addChild(this.submitBtn);

        const inviteText: GameObject = GameObject.Instantiate(Text, {
            name: 'invite_friends_text',
            text: Game.locale.getText('InviteFriends'),
            style: Game.style.getStyle('popup.friends_hub.invite'),
            x: 210,
            y: 120,
            anchor: new Point(0.5, 0.5),
            bounds: new Point(340, 320),
        });
        inviteSplash.addChild(inviteText);
    }
    protected createScrollArea(): void {
        const underlay: GameObject = this.background.find(
            this.underlayParams.name
        );
        const scrollArea: Element = GameObject.Instantiate(FriendHubScroll, {
            name: SCROLL_AREA,
            layout: {
                anchors: [0.5, 1, 0.5, 1],
                pivot: [0.5, 1],
                offsets: [10, -265, 10, -265],
                constrains: {
                    heightMin: 400,
                    heightMax: 400,
                    widthMin: 644,
                    widthMax: 644,
                },
            },
        });

        const underlayCover: GameObject = GameObject.Instantiate(Sprite, {
            name: 'underlay_cover',
            texture: 'mask_base',
            x: -10, // -10
            y: 295,
            anchor: new Point(0.5, 1),
        });
        const underlayCoverArrow: GameObject = GameObject.Instantiate(Sprite, {
            name: 'underlay_cover_arrow',
            texture: 'arrow_toplist_down',
            x: -10, // -10
            y: 285,
            anchor: new Point(0.5, 1),
        });

        underlay.addChild(scrollArea);
        underlay.addChild(underlayCover);
        underlay.addChild(underlayCoverArrow);
    }

    private readonly fillFriendItems = (friendsData: IScoreEntry[]): void => {
        if(!this.background) return;
        const area: Element = this.background.findChildByName(
            SCROLL_AREA
        ) as Element;
        const friendElements: GameObject[] = area.children.filter(
            (child: GameObject) => child.name.includes('friend_item')
        );

        if (area) {
            let elementHeight: number;
            const max: number = Math.max(
                friendElements.length,
                friendsData.length
            );
            for (let i = 0; i < max; i++) {
                let friendItem: FriendItem = friendElements[i] as FriendItem;

                if (!friendItem) {
                    friendItem = GameObject.Instantiate(FriendItem, {
                        playerId: i,
                        offsets: [
                            FRIEND_ITEM_OFFSET.x,
                            -10 + FRIEND_ITEM_OFFSET.y * i,
                            FRIEND_ITEM_OFFSET.x,
                            -10 + FRIEND_ITEM_OFFSET.y * i,
                        ],
                    });
                    area.addChild(friendItem);
                } else if (i >= friendsData.length) {
                    friendItem.destroy();
                    continue;
                }

                friendItem.setPlayerData(friendsData[i]);
                elementHeight = friendItem.container.height;
            }
            area.container.resize(0, 0);
            this.updateFriendTimers();
        }
    };
    public handleStateChanged(state: IGameState) {
        this.updateFriendTimers(state);
        this.updateProgressBar(state);
    }
    protected updateProgressBar(
        state: IGameState = Game.store.getState()
    ): void {
        try {
            const progressBar: GameObject = GameObject.findFirstByName(
                FriendsHubHandler.PROGRESS_BAR_NAME
            );
            const progressText: GameObject = GameObject.findFirstByName(
                FriendsHubHandler.PROGRESS_TEXT_NAME
            );

            const count: number = state.playerState.progress.currencyShareCount;

            if (count >= 10) {
                const system: WorldSystem = this.system.scene.getSystem(
                    WorldSystem
                );
                StartAnimation(system.animator, 'RewardCoins', {
                    scene: system.scene,
                    value: currencyShareReward.value,
                    previousValue: state.playerState.inventory.coins,
                });

                PlayerActions.receiveCurrencyShareReward(
                    currencyShareReward
                );
            } else {
                progressText.getComponent(
                    TextComponent
                ).text = `${count} / ${FRIEND_SHARE_MAX_COUNT}`;
                progressBar.getComponent(SpriteComponent).width =
                    count *
                    ((PROGRESS_BAR_MAX_WIDTH - 70) / FRIEND_SHARE_MAX_COUNT);
            }
        } catch (error) {
            report('Failed to update progress bar in FriendsHub', {
                error,
                once: true,
                sampleRate: 0.1,
            });
        }
    }
    private initTimer(): void {
        this.timer = new Timer();
        this.timer.onUpdate = this.updateFriendTimers;
        this.cleanupManager.add(() => {
            this.timer.stop();
        });
    }

    private readonly updateFriendTimers = (
        state: IGameState = Game.store.getState()
    ): void => {
        const scrollArea: Element = this.background.findChildByName(
            SCROLL_AREA
        ) as Element;

        if (!scrollArea) return;

        scrollArea.children.forEach((friendItem: FriendItem) => {
            friendItem?.updateTimers?.();
        });
    };
}
